import * as z from "zod";
import {
  carrierClaimsDimensionSchema,
  carrierClaimsFilterSchema,
  carrierClaimsGroupBySchema,
} from "./carrier-claims-analytics-common";

export const carrierClaimsBreakdownRowSchema =
  carrierClaimsDimensionSchema.extend({
    created: z.number(),
    submitted: z.number(),
    unsubmitted: z.number(),
    pending: z.number(),
    decided: z.number(),
    approved: z.number(),
    rejected: z.number(),
    medianDaysToSubmit: z.number().nullable(),
    medianDaysToDecision: z.number().nullable(),
    carrierPayoutUsd: z.number(),
    redoKeepRevenueUsd: z.number(),
  });
export type CarrierClaimsBreakdownRow = z.infer<
  typeof carrierClaimsBreakdownRowSchema
>;

export const getCarrierClaimsBreakdown = {
  name: "getCarrierClaimsBreakdown" as const,
  input: carrierClaimsFilterSchema.extend({
    groupBy: carrierClaimsGroupBySchema,
    limit: z.number().int().positive().optional(),
  }),
  output: z.object({
    rows: z.array(carrierClaimsBreakdownRowSchema),
    totalGroups: z.number(),
  }),
};

export type GetCarrierClaimsBreakdownInput = z.infer<
  typeof getCarrierClaimsBreakdown.input
>;
export type GetCarrierClaimsBreakdownOutput = z.infer<
  typeof getCarrierClaimsBreakdown.output
>;
